<oo-loading-container [status]="status()">
  <ng-template>
    @if (initData()) {
      <oo-app-bar (logout)="logout()"
                  [isSuperAdmin]="isSupperAdmin()"
                  [userImage]="initData()!.user.image">
      </oo-app-bar>
      <div class="oo-page-container">
        <router-outlet></router-outlet>
      </div>
    }
  </ng-template>
</oo-loading-container>
